import React from 'react';
import { CotacaoStatus, ItemSemOferta } from '../../../interfaces/PortalCotacoes';
import '../../../shared/feedback/aviso-de-tela.css';

/**
 * Itens que ainda não têm oferta (portal-cotacoes/at-18, reunião com Compras de 29/10/2026: o
 * Phelipe pediu que o sistema aponte o item que ninguém cotou e pergunte se ele vai para outro
 * fornecedor).
 *
 * A lista vem calculada do servidor (`itensSemOferta` do detalhe). 🔴 Ausente ou `null` não desenha
 * nada: é "não sei", e não "tudo cotado". A faixa só afirma o que a consulta respondeu.
 */

interface ItensSemOfertaFaixaProps {
  status: CotacaoStatus;
  itens: ItemSemOferta[] | null | undefined;
  /** Quem pode convidar ou reabrir (COMPRA/ADMIN). O TI só lê (ADR 0012). */
  podeAgir: boolean;
  onConvidar: (cotacaoItemIds: string[]) => void;
  onReabrir: () => void;
}

/** "ninguém respondeu ainda" e "quem respondeu não tinha" pedem leituras diferentes do comprador. */
function situacao(item: ItemSemOferta): string {
  if (item.convidados === 0) return 'nenhum fornecedor recebeu';
  if (item.responderam === 0) return 'ninguém respondeu ainda';
  return `${item.responderam} de ${item.convidados} responderam sem ofertar`;
}

const ItensSemOfertaFaixa: React.FC<ItensSemOfertaFaixaProps> = ({ status, itens, podeAgir, onConvidar, onReabrir }) => {
  if (!itens || itens.length === 0) return null;
  const emNegociacao = status === 'EM_DECISAO';
  const titulo = itens.length === 1 ? '1 item ainda sem oferta' : `${itens.length} itens ainda sem oferta`;

  return (
    <div className="aviso-de-tela" role="status" style={{ marginBottom: 16 }}>
      <strong>{titulo}:</strong>{' '}
      {itens.map((i, idx) => (
        <span key={i.cotacaoItemId}>
          {idx > 0 && '; '}
          {i.descricao} ({situacao(i)})
        </span>
      ))}
      .{' '}
      {podeAgir &&
        (emNegociacao ? (
          <>
            As respostas estão encerradas: para chamar outro fornecedor,{' '}
            <button type="button" className="aviso-de-tela-link" onClick={onReabrir}>
              reabra para respostas
            </button>{' '}
            antes.
          </>
        ) : (
          <button type="button" className="aviso-de-tela-link" onClick={() => onConvidar(itens.map((i) => i.cotacaoItemId))}>
            Convidar outro fornecedor para {itens.length === 1 ? 'este item' : 'estes itens'}
          </button>
        ))}
    </div>
  );
};

export default ItensSemOfertaFaixa;
